import React from 'react';
import SEO from '../components/SEO';

const Stovyklos = () => {
  return (
    <div>
      <SEO 
        title="Stovyklos"
        description="Vaikų ir jaunimo stovyklos Sporto Krante - aktyvus laisvalaikis, sportas, pramogos gamtoje. Saugios ir įdomios atostogos vaikams."
        keywords="stovyklos, vaikų stovyklos, vasaros stovyklos, sporto stovyklos, pramogos vaikams, sporto krantas"
        canonicalUrl="https://sportokrantas.lt/stovyklos"
      />
      {/* First Section - White background, image left 40%, text right 60% */}
      <section className="border-b-[3px] border-black bg-white">
        <div className="grid grid-cols-1 lg:grid-cols-10">
          {/* Image - 40% */}
          <div className="lg:col-span-4 min-h-[400px] overflow-hidden">
            <img 
              src="/img/stovyklos-1.jpg" 
              alt="Jogos stovykla" 
              className="w-full h-full object-cover"
            />
          </div>

          {/* Content - 60% */}
          <div className="lg:col-span-6 px-8 py-12 lg:py-16 lg:px-12 flex flex-col justify-center">
            <h1 className="text-black mb-6 tracking-wide leading-tight text-center" style={{ fontSize: '24px', fontWeight: 700, WebkitTextStroke: '0.3px' }}>
              ERDVĖ JOGOS IR PILATESO STOVYKLOMS - RAMYBĖ, JUDESYS IR BALANSAS
            </h1>
            <div className="space-y-2 text-black leading-relaxed mb-2">
              <p>
                „Sporto krantas" – tai vieta, kur natūraliai dera judesys, kvėpavimas ir poilsis, todėl puikiai tinka jogos, pilateso ir sąmoningo judesio stovykloms.
              </p>
              <p>
                Teritorija ant ežero kranto suteikia galimybę užsiėmimus organizuoti tiek lauke, tiek vidinėse erdvėse. Rytinės praktikos su vaizdu į ežerą ar mišką, vakariniai tempimo ir atsipalaidavimo užsiėmimai bei tylūs pasivaikščiojimai gamtoje kuria visapusišką stovyklos patirtį.
              </p>
              <p>„Sporto krantas" siūlo:</p>
            </div>
            <ul className="list-disc pl-8 space-y-1 text-black mb-2">
              <li>erdves grupinėms jogos ir pilateso praktikoms,</li>
              <li>ramią, privačią aplinką be miesto triukšmo,</li>
              <li>galimybę derinti judesį su poilsiu ir atsistatymu.</li>
            </ul>
            <div className="text-black leading-relaxed mb-2">
              <p>Po praktikos dalyviai gali mėgautis:</p>
            </div>
            <ul className="list-disc pl-8 space-y-1 text-black mb-2">
              <li>pirtimi ir sūkurine vonia raumenų atpalaidavimui,</li>
              <li>maudynėmis ežere šiltuoju metų laiku,</li>
              <li>masažais ir ramiais vakarais.</li>
            </ul>
            <div className="space-y-2 text-black leading-relaxed">
              <p>
                Apgyvendinimas „Sporto krante" leidžia stovyklas planuoti kelioms dienoms ar visam savaitgaliui. Jaukūs kambariai, galimybė pasirūpinti maitinimu ir lėtas dienos ritmas padeda dalyviams pilnai įsitraukti į procesą ir pailsėti ne tik fiziškai, bet ir emociškai.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Second Section - Black background, text left 60%, image right 40% */}
      <section className="border-b-[3px] border-black" style={{ backgroundColor: '#111315' }}>
        <div className="grid grid-cols-1 lg:grid-cols-10">
          {/* Content - 60% */}
          <div className="lg:col-span-6 px-8 py-12 lg:py-16 lg:px-12 flex flex-col justify-center">
            <h2 className="text-white mb-6 tracking-wide leading-tight text-center" style={{ fontSize: '24px', fontWeight: 700, WebkitTextStroke: '0.3px' }}>
              Erdvė tylos stovykloms - ramybė, gylis ir buvimas su savimi
            </h2>
            <div className="space-y-2 text-white leading-relaxed mb-2">
              <p>
                „Sporto krantas" – tai vieta, kur tylą palaiko pati aplinka. Atokiau nuo miesto šurmulio, gamtos apsuptyje, ant ežero kranto, čia natūraliai kuriamos sąlygos tylos, sąmoningumo ir vidinio susitelkimo stovykloms.
              </p>
              <p>
                Teritorijos ramybė, miško ir vandens artumas leidžia atsitraukti nuo išorinių dirgiklių ir susitelkti į vidinius procesus. Čia tyla nėra priverstinė – ji ateina savaime, padėdama nurimti, sulėtėti ir išgirsti save.
              </p>
              <p>„Sporto krantas" tinkamas:</p>
            </div>
            <ul className="list-disc pl-8 space-y-1 text-white mb-2">
              <li>kelių dienų ar savaitgalio tylos stovykloms,</li>
              <li>meditacijos, kvėpavimo ar sąmoningumo praktikoms,</li>
              <li>individualiam ir grupiniam susitelkimui.</li>
            </ul>
            <div className="text-white leading-relaxed mb-2">
              <p>Stovyklų metu galima naudotis:</p>
            </div>
            <ul className="list-disc pl-8 space-y-1 text-white">
              <li>ramiomis vidaus ir lauko erdvėmis praktikoms,</li>
              <li>pasivaikščiojimo takais prie ežero ir miške,</li>
              <li>pirtimi ir SPA erdve švelniam kūno atsistatymui,</li>
              <li>apgyvendinimu, kuris užtikrina tylą ir privatų poilsį.</li>
            </ul>
          </div>

          {/* Image - 40% */}
          <div className="lg:col-span-4 min-h-[400px] overflow-hidden">
            <img 
              src="/img/stovyklos-2.jpg" 
              alt="Tylos stovykla" 
              className="w-full h-full object-cover"
            />
          </div>
        </div>
      </section>

      {/* Third Section - White background, image left 40%, text right 60% */}
      <section className="border-b-[3px] border-black bg-white">
        <div className="grid grid-cols-1 lg:grid-cols-10">
          {/* Image - 40% */}
          <div className="lg:col-span-4 min-h-[400px] overflow-hidden">
            <img 
              src="/img/stovyklos-3.jpg" 
              alt="Teniso stovykla" 
              className="w-full h-full object-cover"
            />
          </div>

          {/* Content - 60% */}
          <div className="lg:col-span-6 px-8 py-12 lg:py-16 lg:px-12 flex flex-col justify-center">
            <h2 className="text-black mb-6 tracking-wide leading-tight text-center" style={{ fontSize: '24px', fontWeight: 700, WebkitTextStroke: '0.3px' }}>
              TENISO IR KITOS SPORTO STOVYKLOS - AKTYVUS POILSIS „SPORTO KRANTE"
            </h2>
            <div className="space-y-2 text-black leading-relaxed mb-2">
              <p>
                Gamtos apsuptyje, ant ežero kranto, čia sudarytos puikios sąlygos teniso ir kitoms sporto stovykloms, skirtoms tiek vaikams, tiek suaugusiesiems ar komandoms.
              </p>
              <p>
                Teritorijoje įrengti modernūs teniso kortai, tinkami treniruotėms, stovyklų užsiėmimams ir draugiškoms varžyboms. Erdvi aplinka leidžia patogiai organizuoti grupines treniruotes, technikos tobulinimą ar fizinio pasirengimo užsiėmimus.
              </p>
              <p>Be teniso, „Sporto krantas" puikiai tinka ir:</p>
            </div>
            <ul className="list-disc pl-8 space-y-1 text-black mb-2">
              <li>bendro fizinio pasirengimo stovykloms,</li>
              <li>sporto klubų išvykoms,</li>
              <li>aktyvaus judesio ir sveikatingumo programoms,</li>
              <li>sporto ir poilsio deriniui.</li>
            </ul>
            <div className="text-black leading-relaxed mb-2">
              <p>Po treniruočių dalyviai gali atsipalaiduoti:</p>
            </div>
            <ul className="list-disc pl-8 space-y-1 text-black mb-2">
              <li>pirtyje ir sūkurinėje vonioje raumenų atsistatymui,</li>
              <li>maudynėmis ežere šiltuoju metų laiku,</li>
              <li>masažais ar ramiu poilsiu gamtoje.</li>
            </ul>
            <div className="space-y-2 text-black leading-relaxed">
              <p>
                Apgyvendinimas ir maitinimas pritaikomi stovyklų ritmui ir poreikiams – galimi pusryčiai, pietūs ir vakarienė, subalansuoti aktyviai judantiems dalyviams.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Fourth Section - Gold background, full width text */}
      <section className="py-16 lg:py-24 border-b-[3px] border-black" style={{ backgroundColor: '#D0AB64' }}>
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-black mb-6 tracking-wide leading-tight text-center" style={{ fontSize: '24px', fontWeight: 700, WebkitTextStroke: '0.3px' }}>
            PIRTYS IR SPA ERDVĖ - ATSISTATYMUI, POILSIUI IR STOVYKLŲ RITMUI
          </h2>
          <div className="space-y-2 text-black leading-relaxed mb-2">
            <p>
              „Sporto kranto" pirties ir SPA erdvė sukurta tam, kad palaikytų kūno ir proto atsistatymą po aktyvios dienos, intensyvių praktikų ar emocinio darbo. Tai svarbi stovyklų, sportinių programų ir sąmoningo poilsio dalis, leidžianti dalyviams pilnai atsipalaiduoti ir atkurti balansą.
            </p>
            <p>
              Erdvėje įrengta pirtis ir sūkurinė vonia, kurios padeda atpalaiduoti raumenis, sumažinti įtampą ir nuraminti mintis. Šiluma, vanduo ir ramybė natūraliai papildo tiek sporto, tiek jogos, pilateso ar tylos stovyklų dienotvarkę.
            </p>
            <p>
              Esant poreikiui, siūlome profesionalaus pirtininko paslaugas – vedamus pirties ritualus, pritaikytus skirtingoms grupėms ir stovyklų pobūdžiui. Tai gali būti:
            </p>
          </div>
          <ul className="list-disc pl-8 space-y-1 text-black">
            <li>lengvi, atpalaiduojantys ritualai po treniruočių,</li>
            <li>gilesni sąmoningo poilsio seansai,</li>
            <li>ramūs, tylai pritaikyti pirties vakarai.</li>
          </ul>
        </div>
      </section>
    </div>
  );
};

export default Stovyklos;
